<template>

<b-row>
  <b-col sm="12">
    <b-card header="Carga masiva">

      <div class="alert alert-info" role="alert">
        <h4 class="alert-heading">Consideraciones</h4>
        <p>
          - Las columnas marcadas con (*) son obligatorias. Descarga el formato <a :href="format_file" target="_blank">aqui</a><br>
          - La carga es única, es decir ningún registro será almacenado existiendo al menos 1 error en la data del archivo. Se deberá corregir.<br>
          - Los códigos de puertos, operaciones y tamaños se despliegan a continuación <br>
          - El archivo a cargar debe ser un .csv
        </p>
        <!-- <hr> -->
        <!-- <p class="mb-0">Whenever you need to, be sure to use margin utilities to keep things nice and tidy.</p> -->
      </div>

      <div class="form-group" style="margin-top: 20px;">
        <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
          <i class="icon-arrow-down"></i> Código Puertos
        </b-link>
        <b-collapse id="collapse1" invisible>
          <table class="table table-hover table-striped table-bordered">
            <thead>
              <tr>
                <th>Código</th>
                <th>Puerto</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(cs, k) in ports" :key="k">
                <td>{{cs.code}}</td>
                <td>{{cs.name}}</td>
              </tr>
            </tbody>
          </table>
        </b-collapse>
      </div>
      <div class="form-group" style="margin-top: 20px;">
        <b-link class="card-header-action btn-minimize" v-b-toggle.collapse2>
          <i class="icon-arrow-down"></i> Código operaciones
        </b-link>
        <b-collapse id="collapse2" invisible>
          <table class="table table-hover table-striped table-bordered">
            <thead>
              <tr>
                <th>Código</th>
                <th>Puerto</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(cs, k) in operations" :key="k">
                <td>{{cs.code}}</td>
                <td>{{cs.name}}</td>
              </tr>
            </tbody>
          </table>
        </b-collapse>
      </div>
      <div class="form-group" style="margin-top: 20px;">
        <b-link class="card-header-action btn-minimize" v-b-toggle.collapse3>
          <i class="icon-arrow-down"></i> Código tamaños contenedores
        </b-link>
        <b-collapse id="collapse3" invisible>
          <table class="table table-hover table-striped table-bordered">
            <thead>
              <tr>
                <th>Código</th>
                <th>Descripción</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(cs, k) in container_sizes" :key="k">
                <td>{{cs.code}}</td>
                <td>{{cs.name}}</td>
              </tr>
            </tbody>
          </table>
        </b-collapse>
      </div>

      <div class="form-group custom-file form-group">
        <input type="file" class="custom-file-input" v-on:change="onFileChange" id="customFile" />
        <label class="custom-file-label" for="customFile">Escoge un archivo .csv</label>
      </div>

      <hr>
      
      <div class="alert alert-danger" v-if="response.recaladaErrors.length">Fila(s) del archivo con error en recalada: {{response.recaladaErrors.join(', ')}} </div>
      <div class="alert alert-danger" v-if="response.cntSizeErrors.length">Fila(s) del archivo con error en dimensión de contenedor: {{response.cntSizeErrors.join(', ')}} </div>
      <div class="alert alert-danger" v-if="response.portErrors.length">Recalada(s) con puerto erróneo: {{response.portErrors.join(', ')}} </div>
      <div class="alert alert-danger" v-if="response.operationErrors.length">Recalada(s) con tipo de operación errónea: {{response.operationErrors.join(', ')}} </div>
      <div class="alert alert-danger" v-if="response.cutoffErrors.length">Recalada(s) con fecha de cutoff inválida: {{response.cutoffErrors.join(', ')}} </div>

    </b-card>
  </b-col>
</b-row>

</template>

<script>
import api from '@/helpers/api'
import constants from '@/constants'
export default {
  data(){
    return{
      format_file: `${process.env.VUE_APP_SOCKET}formatos/FORMATO_CARGA_MASIVA_VACIOS.xls`,
      container_sizes: [],
      ports: [],
      operations: [],
      response: {
        recaladaErrors: [],
        cntSizeErrors: [],
        portErrors: [],
        operationErrors: [],
        cutoffErrors: []
      }
    }
  },
  mounted(){
    api.get("/container_sizes").then(response => {
      this.container_sizes = response.container_sizes;
    });
    
    api.get("/ports").then(response => {
      this.ports = response.ports;
    });

    api.get("/operations").then(response => {
      this.operations = response.operations.filter(op => ['EVA', 'DVA'].includes(op.code));
    });
  },
  methods: {
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      const permitted_ext = [
        "text/comma-separated-values",
        "text/csv",
        "application/csv",
        "application/excel",
        "application/vnd.ms-excel",
        "application/vnd.msexcel"
      ];

      if (!files.length || !permitted_ext.includes(files[0].type)) {
        this.showError("Formato de archivo inválido.");
      } else {
        const formData = new FormData();
        formData.append("file", files[0]);
        api.post(`/empty_containers`, formData).then(response => {
          if(response.success){
            this.$toastr.success('Carga exitosa de contenedores vacíos', 'Vacíos', {
              positionClass: "toast-top-center",
              closeButton: true
            });
          } else {
            this.$toastr.error('Ocurrió un error. Revise detalle de errores', 'Vacíos', {
              positionClass: "toast-top-center",
              closeButton: true
            });
            this.response = response
            console.log(this.response)
            // this.recaladaErrors = response.recaladaErrors
            // this.cntSizeErrors = response.cntSizeErrors
            // this.portErrors = response.portErrors
            // this.operationErrors = response.operationErrors
            // this.cutoffErrors = response.cutoffErrors
          }
        })
      }
    }
  }
}
</script>